export type CustomerSectionKey =
  | 'cadastro'
  | 'filial'
  | 'responsavel'
  | 'endereco'
  | 'planos'
  | 'comissoes'
  | 'contratos'
  | 'os'
  | 'fiscal'
  | 'parametros'
  | 'acessos'
  | 'cobrancas';

export interface CustomerSection {
  key: CustomerSectionKey;
  label: string;
  description: string;
}

/** Ordem do cadastro: Cadastro, Filial, Responsável, Endereço e as demais seções. */
export const CUSTOMER_SECTIONS: CustomerSection[] = [
  { key: 'cadastro', label: 'Cadastro', description: 'Identificação e contato' },
  { key: 'filial', label: 'Filial', description: 'Unidades vinculadas' },
  { key: 'responsavel', label: 'Responsável', description: 'Pessoas de referência' },
  { key: 'endereco', label: 'Endereço', description: 'Endereço principal' },
  { key: 'planos', label: 'Planos', description: 'Soluções contratadas' },
  { key: 'comissoes', label: 'Comissões', description: 'Vínculos comerciais' },
  { key: 'contratos', label: 'Contratos', description: 'Documentos do cliente' },
  { key: 'os', label: 'OS', description: 'Ordens de serviço do cliente' },
  { key: 'fiscal', label: 'Fiscal', description: 'Ambiente e regime' },
  { key: 'parametros', label: 'Parâmetros', description: 'Códigos e limites' },
  { key: 'acessos', label: 'Acessos', description: 'Logins do cliente' },
  { key: 'cobrancas', label: 'Cobranças', description: 'Cobranças do cliente' },
];

export function customerSectionIndex(key: CustomerSectionKey): number {
  return CUSTOMER_SECTIONS.findIndex((section) => section.key === key);
}
